import Vue from 'vue';
import Vuex from 'vuex';
import instance from '../utils/axios';

Vue.use(Vuex);

const userInfo = new Vuex.Store({
    state: {
        userId: null,
        userName: null,
		departmentId: null,
        permissions: [],
        navigationMenus:[],
        showNavBar: false,
        navTitle:"标题"
    },
    mutations: {
        init(state) {
            instance.get('/crm/user/').then((resp) => {
                state.userId = resp.data.Data.userId;
                state.userName = resp.data.Data.name;
				state.departmentId = resp.data.Data.departmentId;
            });
            instance.get('/crm/user/getUserPermission').then((resp) => {
                state.permissions = resp.data.Data;
            });
            instance.get('/crm/user/getUserNavigationMenu').then((resp) => {
                state.navigationMenus = resp.data.Data;
            });
        },
        showNavBar(state) {
            state.showNavBar = true;
        },
        hideNavBar(state) {
            state.showNavBar = false;
        },
        setNavTitle(state,title) {
            state.navTitle = title;
        }
    },
    getters: {
        getUserId: state => state.userId,
        getUserName: state => state.userName,
		getDepartmentId: state => state.departmentId,
        getPermissions: state => state.permissions,
        getNavigationMenus: state => state.navigationMenus,
        getShowNavBar: state => state.showNavBar,
        title: state => state.navTitle
    }
});
export default userInfo;